import { createRoute, redirect } from '@tanstack/react-router';
import { authenticatedRoute } from './authenticated-route';
import { accountMaintenanceRoute } from './features/account-maintenance/routes';
import {
  externalRoute,
  loginRoute,
  resetPasswordRoute,
  unauthorizedRoute,
} from './features/auth/login-routes';
import { DASHBOARD_ROUTES } from './features/dashboard/consts/routes';
import { dashboardRoute } from './features/dashboard/routes';
import { deliveryRoomRoute } from './features/delivery-room/routes';
import { formSysRoute } from './features/form-system/routes';
import { imageManagementRoute } from './features/image-editor/routes';
import { inisRoutes } from './features/my-patient/routes';
import { noticeRoute } from './features/notice/routes';
import { patient360Routes } from './features/patient-360/routes';
import { permissionRouteTree } from './features/permission/routes';
import { IS_PROD, RRWEB_ENABLED } from './lib/env';
import { rootRoute } from './root-route';

const showcaseRoute = !IS_PROD
  ? await import('./showcase/showcase-routes').then(
      ({ showcaseRoute }) => showcaseRoute,
    )
  : undefined;

const rrwebRoutes = RRWEB_ENABLED
  ? await import('./features/rrweb/routes').then(
      ({ rrwebRoutes }) => rrwebRoutes,
    )
  : [];

const indexRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/',
  beforeLoad: () => {
    throw redirect({ to: DASHBOARD_ROUTES.index });
  },
});

export const routeTree = rootRoute.addChildren([
  authenticatedRoute.addChildren([
    indexRoute,
    formSysRoute,
    dashboardRoute,
    imageManagementRoute,
    ...inisRoutes,
    ...patient360Routes,
    accountMaintenanceRoute,
    noticeRoute,
    permissionRouteTree,
    ...rrwebRoutes,
    deliveryRoomRoute,
  ]),
  loginRoute,
  unauthorizedRoute,
  resetPasswordRoute,
  externalRoute,
  ...(showcaseRoute ? [showcaseRoute] : []),
]);
